import { ComponentRef, Injectable, Type, ViewContainerRef } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class DrawerService {
	private hostRef: ViewContainerRef | null = null;
	private activeComponentRef: ComponentRef<any> | null = null;
	private readonly hasContentSubject = new BehaviorSubject<boolean>(false);
	private readonly clearedSubject = new Subject<void>();

	public readonly hasContent$ = this.hasContentSubject.asObservable();
	public readonly cleared$ = this.clearedSubject.asObservable();

	registerHost(host: ViewContainerRef): void {
		this.hostRef = host;
	}

	render<T>(component: Type<T>, configure?: (componentRef: ComponentRef<T>) => void): ComponentRef<T> | null {
		if (!this.hostRef) {
			return null;
		}

		this.clearActiveComponent();
		this.hostRef.clear();

		const componentRef = this.hostRef.createComponent(component);

		configure?.(componentRef);

		this.activeComponentRef = componentRef;
		this.hasContentSubject.next(true);

		return componentRef;
	}

	clear(): void {
		if (this.hostRef) {
			this.hostRef.clear();
		}

		this.clearActiveComponent();
		this.hasContentSubject.next(false);
		this.clearedSubject.next();
	}

	private clearActiveComponent(): void {
		if (this.activeComponentRef) {
			this.activeComponentRef.destroy();
			this.activeComponentRef = null;
		}
	}
}
